import React from 'react';
import SharedSpinnerLoad from 'shared_items/SpinnerLoad';

// Shim de compatibilidade — implementação real em shared_items/SpinnerLoad.jsx (design-system fase 1).
// Renomeado de spinner_load.jsx pra SpinnerLoad.jsx (fase 3c) — todos os 5 call sites atualizados.
const Spinner = (props) => <SharedSpinnerLoad moduleKey="travel" {...props} />;

export default Spinner;
